import React from 'react';
import {Grid} from '@mui/material';
import Goals from '../../features/goals/Goals';
import {useAccountContext} from '../../contexts/AccountContext';
import useTitle from '../../hooks/useTitle';
import {FeatureBoundary} from '../../contexts/FeatureBoundary';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';

function ClientGoalsPage() {
  const {account} = useAccountContext();
  useTitle(`Goals - ${account?.name}`);

  return (
    <FeatureBoundary
      showErrorIfDenied
      features={[GlobalPermissionEnum.can_access_ehons_notes_goals]}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Goals readOnly />
        </Grid>
      </Grid>
    </FeatureBoundary>
  );
}

export default ClientGoalsPage;
